import { render } from "./cpt-quota-progress.vue?vue&type=template&id=5491682e"
import script from "./cpt-quota-progress.vue?vue&type=script&lang=js"
export * from "./cpt-quota-progress.vue?vue&type=script&lang=js"

import "./cpt-quota-progress.vue?vue&type=style&index=0&id=5491682e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__